<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Select New Default List'"
    [canGoBack]="!cameFromApplyListToJobs && !cameFromDeleteList"
    [noBow]="cameFromApplyListToJobs || cameFromDeleteList" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>


      @if (loaded) {
        @if (cameFromDeleteList) {
          <tidy-row [align]="'center'" >
            <tidy-text
              [body]="'Checklist deleted.'" />
          </tidy-row>
          <tidy-row [align]="'center'" >
            <tidy-text
              [body]="'Please select a new default list.'" />
          </tidy-row>
        }
        @if (cameFromApplyListToJobs) {
          <tidy-row [align]="'center'" >
            <tidy-text
              [body]="'Updates saved.'" />
          </tidy-row>
          <tidy-row [align]="'center'" >
            <tidy-text
              [body]="'Please select a new default list.'" />
          </tidy-row>
        }
        <tidy-card>
          <tidy-row>
            <tidy-radio-button
              [label]="'Select the default list at this address.'"
              formControlName="defaultList"
              [form]="form.controls.defaultList"
              [submitted]="submitted"
              [errorMessage]="'Please select an option'"
              [items]="toDoLists" />
          </tidy-row>
        </tidy-card>
        <tidy-button
          [text]="'Set New Default List'"
          [action]="boundUpdateDefaultList"
          class="primary" />
      }

    </tidy-wrapper>
  </form>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
